import { MapPin } from "lucide-react";
import { z } from "zod";

import { SECTION_TYPES } from "@/lib/constants/sections";

// Header variations for geotagged projects section
export const GEOTAGGED_PROJECTS_HEADERS = [
  "Explore the diverse range of projects we've catered to",
  "See where we've made an impact in the community",
  "Discover our completed projects across the area",
  "Browse our work throughout the region",
  "Check out where we've been working lately",
  "View our portfolio of local projects",
  "Explore the projects we've completed nearby",
  "See the variety of work we've done in the area",
  "Take a look at our recent project locations",
  "Discover where our expertise has made a difference",
] as const;

export function getRandomGeotaggedProjectsHeader(): string {
  return GEOTAGGED_PROJECTS_HEADERS[Math.floor(Math.random() * GEOTAGGED_PROJECTS_HEADERS.length)];
}

// typed schema
export const GeotaggedProjectsSectionSchema = z.object({
  type: z.literal(SECTION_TYPES.GEOTAGGED_PROJECTS),
  content: z.object({
    header: z.string().min(1, "Header is required").describe("The header of the section."),
    subheader: z.string().optional().describe("The description of the section."),
    alignment: z.enum(["left", "right"]).nullish().describe("The alignment of the section."),
  }),
});

export type GeotaggedProjectsSection = z.infer<typeof GeotaggedProjectsSectionSchema>;

const geotaggedProjectsSection = {
  type: SECTION_TYPES.GEOTAGGED_PROJECTS,
  content: {
    header: getRandomGeotaggedProjectsHeader(),
    subheader: "Discover where our projects have made an impact.",
    alignment: "left",
  },
  meta: {
    displayName: "Geotagged Projects",
    displayDescription: "Showcase your projects that are geotagged to a specific location.",
    displayIcon: MapPin,
    variantsCount: 2,
  },
} as const;

export default geotaggedProjectsSection;
